import axiosInstance from './axiosInstance';

const documentSettingsService = {
  getDocumentSettings: async () => {
    const response = await axiosInstance.get('/settings/document-settings');
    return response.data;
  },

  // Los opcionales que no vienen en `data` se conservan en el backend.
  updateDocumentSettings: async (data) => {
    const response = await axiosInstance.put('/settings/document-settings', data);
    return response.data;
  },
};

export default documentSettingsService;
